import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import styled, { css } from "styled-components";

import { config } from "_config";

const Container = styled.div`
  width: 100%;
  padding: 25px 32px 56px;
  margin-bottom: 24px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 18px;
  line-height: 47px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 16px;
    `}
`;
const SubTitle = styled.h2`
  margin-top: -7px;
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;
  color: #7b848d;
`;
const Header = styled.thead`
  height: 40px;
`;
const HeaderRow = styled.tr`
  vertical-align: middle;
  border-top: 1px solid #ecedf1;
  border-bottom: 1px solid #ecedf1;
`;
const HeaderCell = styled.th`
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #7b848d;
  ${({ mwidth }) =>
    mwidth &&
    css`
      min-width: ${mwidth}px !important;
      max-width: ${mwidth}px !important;
    `}
`;
const HeaderCellLeft = styled(HeaderCell)`
  text-align: left;
`;
const Body = styled.tbody`
  border: none !important;
`;
const BodyRow = styled(HeaderRow)`
  border-top: none;
  height: 40px;
  ${({ index }) =>
    index % 2 !== 0 &&
    css`
      background-color: #fafaff;
    `}
`;
const BodyCell = styled.td`
  text-align: center;
  font-style: normal;
  font-size: 12px;
  color: #394149;
`;
const BodyCellLeft = styled(BodyCell)`
  text-align: left;

  ${({ mwidth }) =>
    mwidth &&
    css`
      min-width: ${mwidth}px !important;
      max-width: ${mwidth}px !important;
    `}
`;
const InfoRow = styled.div`
  display: flex;
  justify-content: center;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #cd4444;
  margin-top: 16px;
`;
const HelpLink = styled.a`
  margin-left: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #cd4444;
  text-decoration: none;
  &:hover {
    color: #cd4444;
    text-decoration: none;
  }
`;

function TableRow({ index, goods, goodsCategory, goodsServiceDetail, description }) {
  return (
    <BodyRow index={index}>
      <BodyCellLeft mwidth={200}>
        <b>{goods ? "Good" : "Service"}</b> - {goodsCategory}
      </BodyCellLeft>
      <BodyCellLeft mwidth={200}>{goodsCategory?.includes("{") ? description || "-" : "Not required"}</BodyCellLeft>
      <BodyCellLeft mwidth={400}>{goodsServiceDetail}</BodyCellLeft>
    </BodyRow>
  );
}

TableRow.propTypes = {
  index: PropTypes.number,
  goods: PropTypes.bool,
  goodsCategory: PropTypes.string,
  goodsServiceDetail: PropTypes.string,
  description: PropTypes.string,
};

function TrademarkClassifications({ classes }) {
  return (
    <Container>
      <Title>Trademark Classifications</Title>
      <SubTitle>Classification information</SubTitle>
      <Table responsive>
        <Header>
          <HeaderRow>
            <HeaderCellLeft mwidth={300}>GOOD OR SERVICE</HeaderCellLeft>
            <HeaderCellLeft mwidth={200}>ADDITIONAL INFO</HeaderCellLeft>
            <HeaderCellLeft mwidth={400}>DETAILS</HeaderCellLeft>
          </HeaderRow>
        </Header>
        <Body>
          {classes.map((classInfo, idx) => (
            <TableRow key={idx} index={idx} {...classInfo} />
          ))}
        </Body>
      </Table>
      <InfoRow>
        Need to update or delete the class?{" "}
        <HelpLink href={`${config.trademarkUiUrl}/contact`}>Contact Customer Service</HelpLink>
      </InfoRow>
    </Container>
  );
}

TrademarkClassifications.propTypes = {
  classes: PropTypes.arrayOf(PropTypes.object),
};

export default TrademarkClassifications;
